interface IUserFollowConstant {
  TYPE: {
    USER: string;
    COMPANY: string;
  };
}

const UserFollow: IUserFollowConstant = {
  TYPE: {
    USER: 'user',
    COMPANY: 'company',
  },
};

export default UserFollow;
